import { Layout, layoutViews } from "piramis-base-components/src/plugins/AdminTemplate/includes/types/Config";
import { BaseTemplateConfig } from "piramis-base-components/src/plugins/AdminTemplate/NewConfig";
import { EntityTypes } from "piramis-base-components/src/components/SelectEntityWizard/includes/types";
import { actionTypeBreadcrumb, baseBoardBreadcrumbs, baseChannelBreadcrumbs } from "../AppConfigBreadcrumbsHelper";
import i18n from "@/i18n/i18n";
import { BaseItemViewAction } from "../types/BaseItemViewAction";
import TokenId from "piramis-base-components/src/shared/utils/TokenId";

export const routes: BaseTemplateConfig['routes'] = [
  {
    path: '',
    component: layoutViews["Panel"],
    children: [
      {
        name: 'Boards',
        path: '',
        component: () => import('../../views/boards.vue'),
      },
      {
        name: 'Common_settings',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/settings`,
        component: () => import('../../views/board-settings/common-settings.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_common_settings_title') }
            ]
          }
        }
      },
      {
        name: 'OffersList',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/ads`,
        component: () => import('../../views/board-settings/offers-list.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_offers_list_title') },
            ]
          }
        }
      },
      {
        name: 'OffersListItem',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/ads/:adId?/:actionType`,
        component: () => import('../../views/board-settings/offers-list-item.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_offers_list_title'), routeName: 'OffersList' },
              { label: actionTypeBreadcrumb(ctx) }
            ]
          }
        },
        beforeEnter: (to, from, next) => {
          if (!Object.values(BaseItemViewAction).includes(to.params.actionType as BaseItemViewAction)) {
            next({
              name: 'OffersList', params: {
                [EntityTypes.BOT_ID]: to.params[EntityTypes.BOT_ID]
              }
            })
          }

          next()
        }
      },
      {
        name: 'Channels',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/channels`,
        component: () => import('../../views/channels.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_channels_title') },
            ]
          },
        },
      },
      {
        name: 'Bot_feedback',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/feedback`,
        component: () => import('../../views/board-settings/bot-feedback.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_bot_feedback_title') }
            ]
          }
        },
      },
      {
        name: 'posts_planner',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }`,
        component: () => import('../../views/posts-planner.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_posts_planner_title') },
            ]
          }
        },
      },
      {
        name: 'Distributions',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/distributions/`,
        component: () => import('../../views/distributions-list.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_distributions_title') },
            ]
          },
        },
      },
      {
        name: 'Distribution',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/distributions/:distributionId?/:actionType`,
        component: () => import('../../views/distribution-item.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_distributions_title'), routeName: 'Distributions' },
              ...ctx.route.params.distributionId && ctx.route.params.actionType !== BaseItemViewAction.Copy ? [ { label: TokenId.getId(ctx.route.params.distributionId.toString()) } ] : [],
              { label: actionTypeBreadcrumb(ctx) }
            ]
          },
        },
      },
      {

        name: 'Channel_protection',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/channel/:${ [ EntityTypes.CHANNEL_ID ] }/protection`,
        component: () => import('../../views/channel/channel-protection.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              ...baseChannelBreadcrumbs(ctx.route),
              { label: i18n.t('menu_channel_protection_title') },
            ]
          }
        },
      },
      {
          name: 'FlowMasters',
          path: `/board/:${ [ EntityTypes.BOT_ID ] }/flow-masters/`,
          component: () => import('../../views/flow-masters.vue'),
          meta: {
            breadcrumbs: (ctx) => {
              return [
                ...baseBoardBreadcrumbs(ctx.route),
                { label: i18n.t('flowmasters_page_title') },
              ]
            },
        },
      },
      {
        name: 'Users_options',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/users`,
        component: () => import('../../views/Users/Users.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_users_options_title') },
            ]
          }
        },
      },
      {
        name: 'Flows_List',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/flows-list`,
        component: () => import('../../views/Flow/FlowsList.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_flows_list_title') }
            ]
          }
        },
      },
      {
        name: 'Bot_Properties',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/bot-properties`,
        component: () => import('../../views/BotProperties/BotPropertiesView.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_bot_properties_title') },
            ]
          }
        },
      },
      {
        name: 'Shop',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/shop`,
        component: () => import('../../views/shop/shop.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_shop_title') },
            ]
          }
        },
      },
      {
        name: 'Styles',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/styles`,
        component: () => import('../../views/styles.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_styles_title') },
            ]
          },
        }
      },
      {
        name: 'Forms',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/forms`,
        component: () => import('../../views/Forms/form-list.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_forms_title') },
            ]
          },
        },
      },
      {
        name: 'articles_list',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/articles-list`,
        component: () => import('../../views/articles-list.vue'),
        meta: {
          disableLoader: true,
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_articles_list_title') },
            ]
          }
        },
      },
      {
        name: 'Buy_board',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/buy`,
        component: () => import('../../views/buy-board.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_board_personal_title') },
              { label: i18n.t('menu_buy_board_title') },
            ]
          }
        },
      },
      {
        name: 'User_profile',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/user-profile/:user_id`,
        component: () => import('../../views/Users/Profile.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_board_personal_title') },
              { label: i18n.t('menu_users_options_title'), routeName: 'Users_options' },
              { label: i18n.t('menu_user_profile_title') },
            ]
          }
        },
      },
      {
        name: 'article',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/articles-list/:actionType`,
        component: () => import('../../views/article.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_articles_list_title'), routeName: 'articles_list' },
              ...ctx.route.query.articleKey ? [ { label: ctx.route.query.articleKey.toString().split('.')[0] } ] : [],
              { label: actionTypeBreadcrumb(ctx) }
            ]
          },
        }
      },
      {
        name: 'Style',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/styles/:actionType`,
        component: () => import('../../views/style.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_styles_title'), routeName: 'Styles' },
              ...ctx.route.query.styleId ? [ { label: ctx.route.query.styleId.toString().split('.')[0] } ] : [],
              { label: actionTypeBreadcrumb(ctx) }
            ]
          },
        }
      },
      {
        name: 'Full_form',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/forms/:formKey?/:actionType`,
        component: () => import('../../views/Forms/form-item.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_forms_title'), routeName: 'Forms' },
              ...ctx.route.params.formKey ? [ { label: ctx.route.params.formKey.toString().split('.')[0] } ] : [],
              { label: actionTypeBreadcrumb(ctx) }
            ]
          },
        },
        beforeEnter: (to, from, next) => {
          if (!Object.values(BaseItemViewAction).includes(to.params.actionType as BaseItemViewAction)) {
            next({
              name: 'Forms', params: {
                [EntityTypes.BOT_ID]: to.params[EntityTypes.BOT_ID]
              }
            })
          }

          next()
        }
      },
      {
        name: 'Channel_main_settings',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/channel/:${ [ EntityTypes.CHANNEL_ID ] }`,
        component: () => import('../../views/channel/channel-main-settings.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              ...baseChannelBreadcrumbs(ctx.route),
              { label: i18n.t('menu_channel_main_settings_title') }
            ]
          }
        },
      },
      {
        name: 'Channel_comments',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/channel/:${ [ EntityTypes.CHANNEL_ID ] }/comments-settings`,
        component: () => import('../../views/channel/comments-settings.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              ...baseChannelBreadcrumbs(ctx.route),
              { label: i18n.t('menu_channel_comments_title') },
            ]
          }
        },
      },
      {
        name: 'Publish_settings',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/channel/:${ [ EntityTypes.CHANNEL_ID ] }/publish-settings`,
        component: () => import('../../views/channel/publish-settings.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              ...baseChannelBreadcrumbs(ctx.route),
              { label: i18n.t('menu_publish_settings_title') },
            ]
          }
        },
      },
      {
        name: 'approve_balancer',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/channel/:${ [ EntityTypes.CHANNEL_ID ] }/approve-balancer`,
        component: () => import('../../views/channel/approve-balancer-page.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              ...baseChannelBreadcrumbs(ctx.route),
              { label: i18n.t('menu_approve_balancer_title') },
            ]
          }
        },
      },
      {
        name: 'Channel_face_control',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/channel/:${ [ EntityTypes.CHANNEL_ID ] }/face-control`,
        component: () => import('../../views/channel/face-control.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              ...baseChannelBreadcrumbs(ctx.route),
              { label: i18n.t('menu_channel_face_control_title') },
            ]
          }
        },
      },
      {
        name: 'Channel_subscription',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/channel/:${ [ EntityTypes.CHANNEL_ID ] }/subscription`,
        component: () => import('../../views/channel/channel-subscription.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              ...baseChannelBreadcrumbs(ctx.route),
              { label: i18n.t('menu_channel_subscription_title') }
            ]
          }
        },
      },
      {
        name: 'invite_links_list',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/channel/:${ [ EntityTypes.CHANNEL_ID ] }/link-list`,
        component: () => import('../../views/invite-links/link-list.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              ...baseChannelBreadcrumbs(ctx.route),
              { label: i18n.t('menu_invite_links_title') },
            ]
          }
        },
      },
      {
        name: 'invite_link',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/channel/:${ [ EntityTypes.CHANNEL_ID ] }/link/:actionType`,
        component: () => import('../../views/invite-links/link-page.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              ...baseChannelBreadcrumbs(ctx.route),
              { label: i18n.t('menu_invite_links_title'), routeName: 'invite_links_list' },
              ...ctx.route.query.linkCode ? [ { label: ctx.route.query.linkCode.toString().split('.')[0] } ] : [],
              { label: actionTypeBreadcrumb(ctx) }
            ]
          }
        },
      },
      {
        name: 'Channel_statistics',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/channel/:${ [ EntityTypes.CHANNEL_ID ] }/statistics`,
        component: () => import('../../views/channel/channel-statistics.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              ...baseChannelBreadcrumbs(ctx.route),
              { label: i18n.t('menu_statistics_all_title') },
              { label: i18n.t('menu_channel_statistics_title') },
            ]
          }
        },
      },
      {
        name: 'Invite_links_statistics',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/channel/:${ [ EntityTypes.CHANNEL_ID ] }/link-statistics`,
        component: () => import('../../views/invite-links/link-statistics.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              ...baseChannelBreadcrumbs(ctx.route),
              { label: i18n.t('menu_statistics_all_title') },
              { label: i18n.t('menu_invite_links_statistics_title') },
            ]
          }
        },
      },
      {
        name: 'post',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/post/:actionType`,
        component: () => import('../../views/post.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            let label = ''

            if (ctx?.route.params.actionType === 'new') label = i18n.t('new_post').toString()
            if (ctx?.route.params.actionType === 'copy') label = i18n.t('new_post').toString()
            if (ctx?.route.params.actionType === 'edit') label = i18n.t('edit_post').toString()
            if (ctx?.route.params.actionType === 'edit-published') label = i18n.t('edit_published_post').toString()
            if (ctx?.route.params.actionType === 'show-suggest') label = i18n.t('show_suggest').toString()
            if (ctx?.route.params.actionType === 'edit-suggest') label = i18n.t('edit_suggest').toString()

            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_posts_planner_title'), routeName: 'posts_planner' },
              { label }
            ]
          },
        },
      },
      {
        name: 'Buy_channel',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/channel/:${ [ EntityTypes.CHANNEL_ID ] }/buy`,
        component: () => import('../../views/buy-channel.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              ...baseChannelBreadcrumbs(ctx.route),
              { label: i18n.t('menu_buy_channel_title') }
            ]
          }
        },
      },
      {
        name: 'Drafts_list',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/drafts/`,
        component: () => import('../../views/drafts-list.vue'),
        meta: {
          breadcrumbs: (ctx) => {
            return [
              ...baseBoardBreadcrumbs(ctx.route),
              { label: i18n.t('menu_drafts_list_title') },
            ]
          },
        },
      }
    ]
  },
  {
    path: '',
    component: layoutViews[Layout.Fullscreen],
    children: [
      {
        name: 'Flow',
        path: `/board/:${ [ EntityTypes.BOT_ID ] }/flow/:actionType`,
        component: () => import('../../views/Flow/NewFlow.vue'),
      },
      {
        name: 'shared',
        path: '/shared/article/:articleKey',
        component: () => import('../../views/article-read-only.vue'),
        meta: {
          requiresAuth: false
        },
      },
      {
        name: 'Flow_Screenshot',
        path: '/flow-screenshot/:request',
        component: () => import('../../views/Flow/NewFlow.vue'),
        meta: {
          requiresAuth: false
        },
      },
      {
        name: 'Last_form_answer',
        path: `last-answer/:token`,
        component: () => import('../../views/Forms/last-form-answer.vue'),
        meta: {
          requiresAuth: false
        },
      },
      {
        name: 'FormPublic',
        path: '/questionnaire/:formToken',
        component: (): any => import('../../views/form-public.vue'),
        meta: {
          requiresAuth: false,
        },
      }
    ]
  }
]
